(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Custom section positioning for infinite scroll
  class CustomSectionPositioner {
    constructor() {
      this.resultsList = document.querySelector('results-list');
      this.grid = this.resultsList?.querySelector('[ref="grid"]');
      this.customSections = {
        desktop: this.resultsList?.querySelector('.custom-section-desktop'),
        mobile: this.resultsList?.querySelector('.custom-section-mobile'),
      };

      this.loadingIndicator = null;
      this.isLoading = false;

      if (!this.grid || (!this.customSections.desktop && !this.customSections.mobile)) {
        return;
      }

      this.init();
    }

    init() {
      // Position custom sections on initial load
      this.positionCustomSections();
      this.updateCustomSectionVisibility();

      // Listen for infinite scroll updates
      this.observeGridChanges();

      // Listen for scroll events to show loading indicator
      this.observeScrollForLoading();

      // Listen for resize events to handle mobile/desktop switching
      window.addEventListener(
        'resize',
        this.debounce(() => {
          this.positionCustomSections();
          this.updateCustomSectionVisibility();
        }, 250)
      );

      // Also listen for orientation change on mobile
      window.addEventListener(
        'orientationchange',
        this.debounce(() => {
          setTimeout(() => {
            this.positionCustomSections();
            this.updateCustomSectionVisibility();
          }, 100);
        }, 250)
      );

      // Add a media query listener for more precise control
      if (window.matchMedia) {
        const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

        mobileMediaQuery.addListener((e) => {
          if (e.matches) {
            this.updateCustomSectionVisibility();
          }
        });

        desktopMediaQuery.addListener((e) => {
          if (e.matches) {
            this.updateCustomSectionVisibility();
          }
        });
      }
    }

    observeGridChanges() {
      const observer = new MutationObserver((mutations) => {
        let shouldReposition = false;

        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if new product cards were added (infinite scroll)
            const hasNewCards = Array.from(mutation.addedNodes).some(
              (node) =>
                node.nodeType === Node.ELEMENT_NODE &&
                node.classList?.contains('product-grid__item')
            );
            if (hasNewCards) {
              shouldReposition = true;
            }
          }
        });

        if (shouldReposition) {
          // Use requestAnimationFrame to ensure DOM is fully updated
          requestAnimationFrame(() => {
            this.positionCustomSections();
            this.updateCustomSectionVisibility();
          });
        }
      });

      observer.observe(this.grid, {
        childList: true,
        subtree: true,
      });
    }

    positionCustomSections() {
      // Remove any existing custom sections from the grid first
      this.removeExistingCustomSections();

      const isMobile = window.innerWidth < 750;
      const activeSection = isMobile ? this.customSections.mobile : this.customSections.desktop;
      const targetLine = activeSection?.dataset.position;

      if (!activeSection || !targetLine) {
        return;
      }

      const cards = this.grid.querySelectorAll('.product-grid__item');

      if (cards.length === 0) {
        return;
      }

      // Only show custom section if we have page 1 products loaded
      const hasPage1Products = Array.from(cards).some((card) => {
        const cardPage = parseInt(card.getAttribute('data-page') || '1');
        return cardPage === 1;
      });

      if (!hasPage1Products) {
        return;
      }

      // Calculate products per line based on grid width, item width, and gap
      const productsPerLine = this.calculateProductsPerLine();
      const targetLineNum = parseInt(targetLine);
      const targetProductPosition = productsPerLine * targetLineNum;

      // Find the card at the target position
      const insertAfterCard = cards[targetProductPosition - 1];

      if (!insertAfterCard) {
        return;
      }

      // Create a list item wrapper for the custom section
      const listItem = document.createElement('li');
      listItem.className = 'product-grid__custom-section';
      listItem.style.cssText = 'grid-column: 1 / -1; width: 100%;';

      // Clone the custom section content and add device-specific class
      const sectionContent = activeSection.cloneNode(true);
      if (isMobile) {
        sectionContent.classList.add('custom-section-mobile');
        sectionContent.classList.remove('custom-section-desktop');
      } else {
        sectionContent.classList.add('custom-section-desktop');
        sectionContent.classList.remove('custom-section-mobile');
      }

      listItem.appendChild(sectionContent);

      // Insert after the target card
      insertAfterCard.parentNode.insertBefore(listItem, insertAfterCard.nextSibling);
    }

    calculateProductsPerLine() {
      if (!this.grid) return 1;

      // Get grid width
      const gridWidth = this.grid.offsetWidth;

      // Get first product item to measure
      const firstItem = this.grid.querySelector('.product-grid__item');
      if (!firstItem) return 1;

      // Get item width (including margins)
      const itemWidth = firstItem.offsetWidth;

      // Get computed styles to find gap
      const gridStyles = window.getComputedStyle(this.grid);
      const gap = parseFloat(gridStyles.columnGap) || parseFloat(gridStyles.gap) || 0;

      // Calculate products per line
      let productsPerLine = Math.floor((gridWidth + gap) / (itemWidth + gap));

      // Alternative calculation: get actual positions of first two items
      const secondItem = this.grid.querySelectorAll('.product-grid__item')[1];
      if (secondItem) {
        const firstRect = firstItem.getBoundingClientRect();
        const secondRect = secondItem.getBoundingClientRect();

        // If second item is on the same row (similar top position)
        if (Math.abs(firstRect.top - secondRect.top) < 10) {
          // Count items in first row by checking vertical position
          const items = Array.from(this.grid.querySelectorAll('.product-grid__item'));
          const firstRowTop = firstRect.top;
          const itemsInFirstRow = items.filter((item) => {
            const rect = item.getBoundingClientRect();
            return Math.abs(rect.top - firstRowTop) < 10;
          }).length;

          if (itemsInFirstRow > 0) {
            productsPerLine = itemsInFirstRow;
          }
        }
      }

      return Math.max(1, productsPerLine);
    }

    removeExistingCustomSections() {
      // Remove any existing custom sections from the grid
      const existingSections = this.grid.querySelectorAll('.product-grid__custom-section');
      existingSections.forEach((section) => section.remove());
    }

    updateCustomSectionVisibility() {
      const isMobile = window.innerWidth < 750;
      const cards = this.grid?.querySelectorAll('.product-grid__item');

      if (!cards || cards.length === 0) {
        return;
      }

      // Check if we have page 1 products loaded
      const hasPage1Products = Array.from(cards).some((card) => {
        const cardPage = parseInt(card.getAttribute('data-page') || '1');
        return cardPage === 1;
      });

      // Find the correctly positioned custom section (the one inside the grid)
      const positionedMobileSection = this.grid?.querySelector(
        '.product-grid__custom-section .custom-section-mobile'
      );
      const positionedDesktopSection = this.grid?.querySelector(
        '.product-grid__custom-section .custom-section-desktop'
      );

      // Show/hide the correctly positioned sections based on device and page 1 status
      if (positionedMobileSection) {
        const wrapper = positionedMobileSection.querySelector('.custom-section-wrapper');
        const hasContent = wrapper && wrapper.children.length > 0;
        const shouldShowMobile = isMobile && hasPage1Products && hasContent;
        positionedMobileSection.style.cssText = shouldShowMobile
          ? 'display: block !important; visibility: visible !important; opacity: 1 !important;'
          : 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
      }

      if (positionedDesktopSection) {
        const wrapper = positionedDesktopSection.querySelector('.custom-section-wrapper');
        const hasContent = wrapper && wrapper.children.length > 0;
        const shouldShowDesktop = !isMobile && hasPage1Products && hasContent;
        positionedDesktopSection.style.cssText = shouldShowDesktop
          ? 'display: block !important; visibility: visible !important; opacity: 1 !important;'
          : 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
      }
    }

    observeScrollForLoading() {
      let scrollTimeout;

      window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
          const firstProduct = this.grid?.querySelector('.product-grid__item');
          if (!firstProduct) return;

          const rect = firstProduct.getBoundingClientRect();
          const isNearTop = rect.top <= 100; // Within 100px of top

          // Check if we have page 1 products loaded
          const hasPage1Products = Array.from(
            this.grid.querySelectorAll('.product-grid__item')
          ).some((card) => {
            const cardPage = parseInt(card.getAttribute('data-page') || '1');
            return cardPage === 1;
          });

          if (isNearTop && !hasPage1Products && !this.isLoading) {
            this.showLoadingIndicator();
          } else if (hasPage1Products && this.loadingIndicator) {
            this.hideLoadingIndicator();
            // Update custom section visibility when page 1 products are loaded
            this.updateCustomSectionVisibility();
          }
        }, 100);
      });
    }

    showLoadingIndicator() {
      if (this.loadingIndicator) return;

      this.isLoading = true;
      this.loadingIndicator = document.createElement('div');
      this.loadingIndicator.className = 'paginated-list__loading-indicator';
      this.loadingIndicator.textContent = 'Loading more products...';

      // Insert at the top of the grid
      if (this.grid?.parentNode) {
        this.grid.parentNode.insertBefore(this.loadingIndicator, this.grid);
      }
    }

    hideLoadingIndicator() {
      if (this.loadingIndicator) {
        this.loadingIndicator.remove();
        this.loadingIndicator = null;
        this.isLoading = false;
      }
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const positioner = new CustomSectionPositioner();

    // Update custom section visibility on initial load
    if (positioner) {
      // Check if we're on page 1 (no page param or page=1)
      const url = new URL(window.location.href);
      const pageParam = url.searchParams.get('page');
      const isPage1 = !pageParam || pageParam === '1';

      if (isPage1) {
        // Wait for products to load, then update visibility
        const checkAndUpdateVisibility = () => {
          const products = document.querySelectorAll('.product-grid__item');
          const mobileSection = document.querySelector('.custom-section-mobile');
          const desktopSection = document.querySelector('.custom-section-desktop');

          if (products.length > 0) {
            positioner.positionCustomSections();
            positioner.updateCustomSectionVisibility();
          } else {
            // If products not loaded yet, try again after a short delay
            setTimeout(checkAndUpdateVisibility, 100);
          }
        };

        // Start checking after a brief delay
        setTimeout(checkAndUpdateVisibility, 200);
      }
    }

    // Auto-scroll to first product if page parameter exists
    const url = new URL(window.location.href);
    const pageParam = url.searchParams.get('page');

    if (pageParam && pageParam !== '1') {
      // Wait for products to load, then scroll to first product
      const scrollToFirstProduct = () => {
        const firstProduct = document.querySelector('.product-grid__item');
        if (firstProduct) {
          firstProduct.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        } else {
          // If products not loaded yet, try again after a short delay
          setTimeout(scrollToFirstProduct, 100);
        }
      };

      // Start checking after a brief delay to ensure DOM is ready
      setTimeout(scrollToFirstProduct, 200);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
